import { SyncDownOptionsEntity } from "./options-entity";
import { ApiRequestOptions } from "../../../core/services/api/request-options";
import { ISyncDownOptions } from "./options.interface";

export interface ISyncDownOptionsArgs {
    accountId: string;
    query?: { [key: string]: any };
    since?: Date;
    quiet?: boolean;
    force?: boolean;
}

const getDefaults = () => {
    return {
        accountId: undefined,
        query: undefined,
        since: undefined,
        quiet: false,
        force: false
    };
};

export class SyncDownOptions implements ISyncDownOptions {

    protected accountId: string;
    protected since: Date;
    protected query: { [key: string]: any } = {};
    protected quiet: boolean;
    protected force: boolean;
    protected entities: Array<SyncDownOptionsEntity> = [];

    constructor(args?: ISyncDownOptionsArgs) {
        const _args = { ...getDefaults(), ...args};
        this.accountId = _args.accountId;
        this.force = _args.force;
        this.query = _args.query;
        this.quiet = _args.quiet;
        this.since = _args.since;
    }

    setAccountId(accountId: string): void {
        this.accountId = accountId;
    }

    getAccountId(): string {
        return this.accountId;
    }

    getAuthenticated(): boolean {
        return true;
    }

    getQuiet(): boolean {
        return this.quiet;
    }

    setQuiet(quiet: boolean): SyncDownOptions {
        this.quiet = quiet;
        this.entities.forEach(option => option.setQuiet(quiet));
        return this;
    }

    getSince(): Date {
        return this.since;
    }

    setSince(since: Date): SyncDownOptions {
        this.since = since;
        this.entities.forEach(option => option.setSince(since));
        return this;
    }

    getQuery(): object {
        return this.query;
    }

    setQuery(query: object): SyncDownOptions {
        this.query = query;
        return this;
    }

    addEntity(entityOptions: SyncDownOptionsEntity): SyncDownOptions {
        entityOptions.setSince(this.getSince());
        entityOptions.setQuiet(this.getQuiet());
        this.entities.push(entityOptions);
        return this;
    }

    getEntityOptions(): Array<SyncDownOptionsEntity> {
        return this.entities.sort((a, b) => a.getPriority() - b.getPriority());
    }

    getForce(): boolean {
        return this.force;
    }

    setForce(value: boolean): SyncDownOptions {
        this.force = value;
        return this;
    }

    toApiRequestOptions(): ApiRequestOptions {
        return new ApiRequestOptions({
            authenticated: true,
            since: this.getSince(),
            query: this.getQuery()
        });
    }
}



// WEBPACK FOOTER //
// ./src/vas/services/sync-down/options.ts